import styles from "@styles/pages/cdp/segmentations.module.scss";

import { Button, Checkbox, Drawer, Radio } from "@components";
import { useEffect, useState } from "react";
import { InputSearch } from "shared/components/InputSearch";
import { Modifiers } from "./Modifiers";
import { getAskedForLabel } from "./Segments";

const clone = (obj) => JSON.parse(JSON.stringify(obj));

export default function SeeMoreSegmentation({
  visible,
  category,
  segments,
  allSegments,
  onClose,
  onConfirmSegments,
}) {
  const [search, setSearch] = useState("");
  const [tempSegments, setTempSegments] = useState(() => clone(segments));

  const filteredOptions = category.options.filter((c) => {
    return !!search
      ? c.name?.toLowerCase().includes(search.toLowerCase())
      : true;
  });

  useEffect(() => {
    setTempSegments(clone(segments));
  }, [segments]);

  const segmentsCopy = clone(tempSegments);

  const selectedCategory = allSegments.find((item) => item.id === category.id);

  const activeModifier =
    tempSegments?.[category.id]?.modifier ||
    selectedCategory?.modifiers?.[0] ||
    null;

  const handleSelectsegments = ({ group, value, modifier }) => {
    segmentsCopy[group.id] = segmentsCopy[group.id] || {};

    const neverOrHasOnly =
      activeModifier?.id === "never" ||
      activeModifier?.id === "has_only" ||
      modifier?.id === "never" ||
      modifier?.id === "has_only";

    if (!!modifier && modifier.id && modifier.name) {
      segmentsCopy[group.id].modifier = {
        id: modifier.id,
        name: modifier.name,
      };
    }

    if (neverOrHasOnly) segmentsCopy[group.id].options = [];

    if (value) {
      const index = segmentsCopy[group.id]?.options?.findIndex(
        (option) => option.id === value.id
      );

      if (index !== -1 && segmentsCopy[group.id]?.options) {
        segmentsCopy[group.id]?.options?.splice(index, 1);
      } else {
        segmentsCopy[group.id] = {
          ...segmentsCopy[group.id],
          name: group.name,
          options:
            segmentsCopy[group.id].options && !neverOrHasOnly
              ? [...segmentsCopy[group.id].options, value]
              : [value],
        };
      }
    }

    setTempSegments(segmentsCopy);
  };

  const selectedOptions = filteredOptions.filter((item) =>
    segments?.[category.id]?.options?.some((o) => o.id === item.id)
  );

  const Box = ({ category, option, index, selected, activeModifier }) => {
    const neverOrHasOnly = ["never", "has_only"].includes(activeModifier?.id);

    const askedFor = [
      "unit_id",
      "brand_id",
      "source_id",
      "order_region",
      "order_city",
      "order_state",
    ].includes(category?.id);

    return (
      <div
        className={styles.condition}
        key={index}
        onClick={() => handleSelectsegments({ group: category, value: option })}
      >
        <div className="d-flex align-center">
          {!neverOrHasOnly ? (
            <Checkbox value={option.id} checked={selected} readOnly />
          ) : (
            <Radio family="box" value={true} checked={selected} readOnly />
          )}
          <div className={styles.divisor} />
          <div className="d-flex flex-column w-100">
            {askedFor && (
              <p className={styles.askedFor}>
                {getAskedForLabel(activeModifier)}
              </p>
            )}
            <p className={styles.name} title={option.name}>
              {option.name}
            </p>
          </div>
        </div>
        <span className={styles.quantity}>
          {Number(option?.data?.[activeModifier?.id] || 0).toLocaleString(
            "pt-BR"
          )}
        </span>
      </div>
    );
  };

  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      withoutTransition
      direction="full-center"
      showCloseButton={false}
    >
      <div className={styles.seeMoreSegmentation}>
        <div className={styles.seeMoreHeader}>
          <p className={styles.title}>{category.name}</p>
          <div className="d-flex align-center">
            <InputSearch
              search
              value={search}
              placeholder="Buscar por..."
              design="two"
              onChange={(e) => setSearch(e.target.value)}
            />
            <div className={styles.divisor} />
            <div className={styles.close} onClick={onClose}>
              <i className="fas fa-times" />
            </div>
          </div>
        </div>

        <div className={styles.seeMoreContainer}>
          <div className={styles.scrollContainer}>
            <div className="d-flex justify-end">
              {category?.modifiers?.length > 0 && (
                <Modifiers
                  modifiers={category.modifiers}
                  activeModifier={activeModifier}
                  onChangeModifier={(modifier) => {
                    handleSelectsegments({ group: category, modifier });
                  }}
                />
              )}
            </div>

            {selectedOptions.length > 0 && (
              <>
                <div className="d-flex align-center justify-between">
                  <p className={styles.totalVariables}>Selecionado(s)</p>
                </div>

                <div className={styles.selectedConditions}>
                  {selectedOptions.map((option, index) => {
                    const selected = tempSegments?.[category.id]?.options?.some(
                      (o) => o.id === option.id
                    );

                    return (
                      <Box
                        category={category}
                        option={option}
                        index={index}
                        selected={selected}
                        activeModifier={activeModifier}
                      />
                    );
                  })}
                </div>
              </>
            )}

            <div className="d-flex align-center justify-between">
              <p className={styles.totalVariables}>
                Todos ({filteredOptions.length - selectedOptions.length})
              </p>
            </div>
            <div className={styles.conditions}>
              {filteredOptions
                .filter((option) => !selectedOptions.includes(option))
                .map((option, index) => {
                  const selected = tempSegments?.[category.id]?.options?.some(
                    (o) => o.id === option.id
                  );

                  return (
                    <Box
                      key={index}
                      category={category}
                      option={option}
                      index={index}
                      selected={selected}
                      activeModifier={activeModifier}
                    />
                  );
                })}
            </div>
          </div>

          <div className={styles.seeMoreFooter}>
            <Button
              design="primary"
              disabled={
                (!tempSegments?.[category.id]?.options ||
                  tempSegments?.[category.id]?.options?.length === 0) &&
                selectedCategory?.options?.length > 0
              }
              onClick={() => {
                onConfirmSegments(tempSegments, category, activeModifier);
              }}
            >
              Confirmar
            </Button>
          </div>
        </div>
      </div>
    </Drawer>
  );
}
